import React from "react";
import { Modal, Button } from "@toddle-edu/ds-web";

import classes from "./DeleteConversation.scss";

import { useI18n } from "Hooks";

const DeleteConversation = props => {
  const { onModalClose, onDeleteConversation } = props;
  const { t } = useI18n(["common"]);

  const onDeleteButtonClick = () => {
    onDeleteConversation();
    onModalClose();
  };

  return (
    <Modal width="528px" height="max-content" onClose={onModalClose}>
      <Modal.Header title={t("common:delete")} />
      <Modal.Body>
        <div>{"Are you sure want to delete this conversation?"}</div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button size="large" variant="outlined-subtle" onClick={onModalClose}>
            {t("common:cancel")}
          </Button>
          <Button
            size="large"
            variant="destructive"
            onClick={onDeleteButtonClick}
          >
            {t("common:delete")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConversation;
